var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal && _vm.showModal.show
    ? _c(
        "div",
        { staticClass: "recipiente" },
        [
          _vm.showModal && _vm.showModal.view == _vm.compra
            ? _c("IncluirAtivo", {
                staticClass: "conteudo",
                attrs: {
                  showModal: _vm.showModal,
                  items: _vm.items,
                  botaoCompraClicado: _vm.botaoCompraClicado,
                  currentPropertie: _vm.currentPropertie,
                  respGetAtiTipUserId_prop: _vm.respGetAtiTipUserId
                },
                on: {
                  closeModal: _vm.closeModal,
                  onChange: _vm.onChange,
                  execCompraAtivo: _vm.execCompraAtivo,
                  opCtrlState: _vm.opCtrlChanged
                }
              })
            : _vm._e(),
          _vm.showModal && _vm.showModal.view == _vm.venda
            ? _c("ExcluirAtivo", {
                staticClass: "conteudo",
                attrs: {
                  showModal: _vm.showModal,
                  items: _vm.items,
                  currentPropertie: _vm.currentPropertie,
                  respGetAtiTipUserId_prop: _vm.respGetAtiTipUserId
                },
                on: {
                  closeModal: _vm.closeModal,
                  onChange: _vm.onChange,
                  execVenda: _vm.execVenda,
                  deleteCompraAtivo: _vm.deleteCompraAtivo
                }
              })
            : _vm._e(),
          _vm.showModal && _vm.showModal.view === _vm.estrategia
            ? _c("EditarEstrategia", {
                staticClass: "conteudo",
                attrs: {
                  showModal: _vm.showModal,
                  tipos: _vm.items,
                  ativos: _vm.loadedItems
                },
                on: {
                  closeModal: _vm.closeModalNovoUsuario,
                  onChange: _vm.onChange
                }
              })
            : _vm._e(),
          _vm.showModal && _vm.showModal.view == _vm.novoUser
            ? _c("NovoUsuarioComponent", {
                staticClass: "conteudo",
                attrs: {
                  currentPropertie: _vm.currentPropertie,
                  loading: _vm.loading,
                  botaoRegistrarUsuarioClicado: _vm.botaoRegistrarUsuarioClicado
                },
                on: {
                  closeModal: _vm.closeModal,
                  execRegisterUser: _vm.execRegisterUser
                }
              })
            : _vm._e(),
          _vm.showModal && _vm.showModal.view == _vm.editarUser
            ? _c("EditarUsuarioComponent", {
                staticClass: "conteudo",
                attrs: {
                  botaoSalvarAlteracoesUsuarioClicado:
                    _vm.botaoSalvarAlteracoesUsuarioClicado,
                  loading: _vm.loading,
                  currentPropertie: _vm.currentPropertie,
                  userToEditar: _vm.userToEditar
                },
                on: {
                  closeModal: _vm.closeModal,
                  execUpdateUser: _vm.execUpdateUser
                }
              })
            : _vm._e(),
          _vm.showModal && _vm.showModal.view === _vm.compraAcessor
            ? _c(
                "div",
                { staticClass: "conteudo" },
                [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "tipo-ativo" },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "flex-column mt-7",
                          attrs: { align: "start" }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("Carteira")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-select", {
                                staticClass: "input",
                                attrs: {
                                  attach: "",
                                  "return-object": "",
                                  items: _vm.items,
                                  "item-text": "name",
                                  "menu-props": { bottom: true, offsetY: true },
                                  placeholder: "Selecione a carteira/usuario",
                                  color: "secondary",
                                  required: "",
                                  outlined: "",
                                  rounded: "",
                                  dense: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onChange($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "keep-alive",
                    [
                      _c(_vm.showModal.view, {
                        tag: "component",
                        attrs: {
                          respGetAtiTipUserId_prop: _vm.respGetAtiTipUserId,
                          tipoAtivo: _vm.currentPropertie,
                          ativoNovoOuExistente: _vm.ativoNovoOuExistente
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.objetoEhVazio(_vm.currentPropertie)
                    ? _c("div", { staticClass: "btn-comprar" }, [
                        _c("span", { on: { click: _vm.exec } }, [
                          _vm._v("Incluir")
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.showModal && _vm.showModal.view === _vm.vendaAcessor
            ? _c(
                "div",
                { staticClass: "conteudo" },
                [
                  _vm._m(1),
                  _c(
                    "div",
                    { staticClass: "tipo-ativo" },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "flex-column mt-7",
                          attrs: { align: "start" }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column align-left py-0"
                            },
                            [
                              _c("span", { staticClass: "text-filelds" }, [
                                _vm._v("Carteira")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-select", {
                                staticClass: "input",
                                attrs: {
                                  items: _vm.userList,
                                  "item-text": "userName",
                                  "item-value": "id",
                                  "menu-props": { bottom: true, offsetY: true },
                                  placeholder: "Selecione a carteira/usuario",
                                  color: "secondary",
                                  required: "",
                                  outlined: "",
                                  rounded: "",
                                  dense: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onChangeAcessor($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "btn-close", on: { click: _vm.closeModal } },
                    [
                      _c("v-img", {
                        attrs: { src: require("@/assets/icons/clear_icon.svg") }
                      })
                    ],
                    1
                  ),
                  _vm.userSelected
                    ? _c(
                        "div",
                        { staticClass: "tipo-ativo" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "flex-column mt-7",
                              attrs: { align: "start" }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex flex-column align-left py-0"
                                },
                                [
                                  _c("span", { staticClass: "text-filelds" }, [
                                    _vm._v("Tipo de ativo 2")
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                [
                                  _c("v-select", {
                                    staticClass: "input",
                                    attrs: {
                                      items: _vm.items,
                                      "item-text": "name",
                                      "menu-props": {
                                        bottom: true,
                                        offsetY: true
                                      },
                                      placeholder: "Selecione",
                                      color: "secondary",
                                      required: "",
                                      outlined: "",
                                      rounded: "",
                                      dense: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onChange($event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "keep-alive",
                    [
                      _c(_vm.showModal.view, {
                        tag: "component",
                        attrs: {
                          tipoAtivo: _vm.currentPropertie,
                          botaoCompraClicado: _vm.botaoCompraClicado,
                          userToEnviarParaAtivos: _vm.userToEnviarParaAtivos,
                          ativoNovoOuExistente: _vm.ativoNovoOuExistente
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.objetoEhVazio(_vm.currentPropertie)
                    ? _c("div", { staticClass: "btn-venda" }, [
                        _c("span", { on: { click: _vm.execVenda } }, [
                          _vm._v("Confirmar venda")
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [
        _vm._v("Incluir "),
        _c("span", { staticStyle: { color: "#b5e546" } }, [_vm._v("Ativo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [
        _vm._v("Excluir "),
        _c("span", { staticStyle: { color: "#f25a5a" } }, [_vm._v("Ativo")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }